import { Container, Grid, Typography, makeStyles } from "@material-ui/core";

import { ITheme } from "../constants/theme";
import React from "react";

interface PropTypesI {
  title: string;
  children?: React.ReactNode;
}

export const InfoBox = (props: PropTypesI) => {
  const classes = useStyles();

  return (
    <Container className={classes.basicInformationContainer}>
      <Grid container>
        <Grid container className={classes.infoTitle}>
          <Typography variant="h6" component="span">
            {props.title}
          </Typography>
        </Grid>
        {props.children}
      </Grid>
    </Container>
  );
};

const useStyles = makeStyles((theme: ITheme) => ({
  basicInformationContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "18px 24px 0",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    boxSizing: "border-box",
    borderRadius: "20px",
    marginBottom: 24,
  },
  infoTitle: {
    marginTop: 8,
  },
  infoTextContainer: {
    paddingTop: 15,
    paddingBottom: 15,
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
  },
  infoTextContainerLastRow: {
    paddingTop: 15,
    paddingBottom: 15,
  },
}));
